import IconSimpleView from './IconSimpleView'

export default IconSimpleView
